import http from "@seims/shared/src/services/HttpService";

var endpoint = `system/financialyear`;
const headers = {};

const addFinYear = async (record) => {
  
    const response = http.post(`${endpoint}/create?financialYear=${record.value}`
    );
    return response;
  };

const editFinYear = async (values) => {
  
    const response = http.patch(`${endpoint}/activate`, values
    );
    return response;
  };

const getAllFinYears = async (all=false) => {
    const response = await http.get(`${endpoint}/list?all=${all}`);
    return response;
  };

const getActiveFinYear = async () => {
    //No endpoint for this as yet
    const response = await http.get(`${endpoint}/isactive`);
    return response;
  };

export default {addFinYear, editFinYear, getAllFinYears, getActiveFinYear}